import ConsultantReferralsReceived from './ConsultantReferralsReceived';
export default ConsultantReferralsReceived;